import { getMessageFromError } from '../utils/functions'

const PREFIX = 'admin/feedback'
export default {
  /* -------------------------------------------------------------------------- */
  /*                                List Feedback                             */
  /* -------------------------------------------------------------------------- */
  async get({ commit }, params) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${PREFIX}/list`, { params })
      if (params.type == 'dropdown') {
        const result = res.data.data.results.map((c) => ({
          value: c._id,
          label: c.title
        }))
        return {
          data: result
        }
      } else {
        commit('SET_STATE', {
          action: 'listLoading',
          data: false
        })
        commit('SET_STATE', {
          action: 'records',
          data: res.data.data.results
        })
        commit('SET_STATE', {
          action: 'total',
          data: res.data.data.totalResults
        })
        commit('SET_STATE', {
          action: 'FilteredCount',
          data: res.data.data.totalResults
        })
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },
  async getUnreadCount({ commit }) {
    try {
      const res = await this.$http.get(`${PREFIX}/count`)
      commit('SET_STATE', {
        action: 'unreadCount',
        data: res.data.data.unreadFeedback
      })
      commit('SET_STATE', {
        action: 'gurudwaraOnboardCount',
        data: res.data.data.unreadGurudwaraOnboard
      })
    } catch (error) {
      console.error('Error fetching unread feedback count:', error)
    }
  }
}
